import { render, staticRenderFns } from "./calidad.vue?vue&type=template&id=4c8ae092&scoped=true"
import script from "./calidad.vue?vue&type=script&lang=js"
export * from "./calidad.vue?vue&type=script&lang=js"
import style0 from "./calidad.vue?vue&type=style&index=0&id=4c8ae092&prod&lang=css"
import style1 from "./calidad.vue?vue&type=style&index=1&id=4c8ae092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ae092",
  null
  
)

export default component.exports